import React, { useState, useEffect } from 'react'
import Joyride from 'react-joyride';
import { useTranslation } from 'react-i18next';
import { optionStyles, locale } from '../customize';
import { useTutorialContext } from '../../GuideTour/TutorialProvider';

export default function IntroduceGuide({ onStart, onCompleteIntro, setStateTutorialBox, notCompletedSetting }) {
    const [loader, setLoader] = useState(false)
    const [stepIndex, setStepIndex] = useState(0)
    const { t } = useTranslation()
    const { setTutorialBox, setTutorialStep1 } = useTutorialContext()

    useEffect(() => {
        setTimeout(() => setLoader(true), 1200)
    }, [])

    const stepIntro = [
        {
            target: '.ListGroup__group--3qLSi',
            content: t('features.GuideTour.IntroduceGuide.0'),
            placement: 'right',
            disableBeacon: true,
        },
        {
            target: '#step-1',
            content: t('features.GuideTour.IntroduceGuide.1'),
            placement: 'right',
        },
        {
            target: '#step-2',
            content: t('features.GuideTour.IntroduceGuide.2'),
            placement: 'right',
        },
        {
            target: '#step-3',
            content: t('features.GuideTour.IntroduceGuide.3'),
            placement: 'right',
        },
        {
            target: '#show-again',
            content: t('features.GuideTour.IntroduceGuide.4'),
            placement: 'right',
        }
    ];

    const setTourCompleted = () => {
        setStepIndex(0)
        setTutorialBox({ onOpen: true, onStart: false, onCompleteIntro: true }).then(() => {
            setStateTutorialBox()
        })
        if (notCompletedSetting.length == 3)
            setTutorialStep1({ run: true, stepIndex: 0, tourCompleted: false, type: 'edit' })
    }
    const setTourSkipped = () => {
        setStepIndex(0)
        setTutorialBox({ onOpen: true, onStart: false, onCompleteIntro: true }).then(() => {
            setStateTutorialBox()
        })
    }

    const handleCallback = data => {
        const { action, index, lifecycle, type } = data;
        const newIndex = index + (action === 'prev' ? -1 : 1);

        if (action === 'skip') {
            setTourSkipped()
        }
        else if (type === 'step:after' && index === 0) {
            setStepIndex(newIndex)
        }
        else if (type === 'step:after' && index === 1) {
            setStepIndex(newIndex)
        }
        else if (type === 'step:after' && index === 2) {
            setStepIndex(newIndex)
        }
        else if (type === 'step:after' && index === 3) {
            setStepIndex(newIndex)
        }
        else if (type === 'step:after' && index === 4) {
            if (action === 'prev') {
                setStepIndex(newIndex)
            }
            else if (lifecycle === 'complete')
                setTourCompleted()
        }
    };

    return (
        <div>
            {loader &&
                <Joyride
                    steps={stepIntro}
                    run={onStart && !onCompleteIntro}
                    stepIndex={stepIndex}
                    callback={handleCallback}
                    styles={optionStyles}
                    locale={locale(t)}

                    continuous
                    scrollToFirstStep
                    hideCloseButton
                    showProgress
                    showSkipButton
                    disableOverlayClose
                />}
        </div>
    )
}
